<template>
  <div>
    <van-dialog v-model="refundVisible" title="退款/调拨" width="95%" style="height:80%" class="editClue" >
      <van-form ref="refundForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">已充值信息</van-divider>
        <div class="card" style="padding: 5px;min-height: 20px;margin-bottom: 0">
          <div class="list-wrap van-hairline--top" style="padding-top: 0">
            <div class="item" style="padding-left:70px;text-indent:-70px;">
              <span class="key">合同信息：</span>
              <span class="value">{{ rechargeInfo.contractNum }}  {{ rechargeInfo.contractName }}</span>
            </div>
            <!-- <div class="item" >
              <span class="key">合同编号：</span>
              <span class="value">{{ rechargeInfo.contractNum }}</span>
            </div> -->
            <div class="item" style="padding-left:70px;text-indent:-70px;">
              <span class="key">项目名称：</span>
              <span class="value">{{ rechargeInfo.projectName}}</span>
            </div>
            <div class="item" >
              <span class="key">所属服务商ID：</span>
              <span class="value">{{ rechargeInfo.serviceId }}</span>
            </div>
            <div class="item" v-if="rechargeInfo.subAccountId">
              <span class="key">子账户ID：</span>
              <span class="value">{{ rechargeInfo.subAccountId }}</span>
            </div>
            <div class="item">
              <span class="key">账户ID：</span>
              <span class="value">{{ rechargeInfo.accountNo }}</span>
            </div>
            <div class="item">
              <span class="key">现金金额：</span>
              <span class="value" style="color: #ee0a24;">
                ￥{{rechargeInfo.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(rechargeInfo.payMoney)}}</span>
              </span>
            </div>
            <div class="item">
              <span class="key">账户币：</span>
              <span class="value">{{ rechargeInfo.rechargeMoney }}</span>
            </div>
            <div class="item">
              <span class="key">充值用户：</span>
              <span class="value">{{ rechargeInfo.mediaUserName }}   {{ rechargeInfo.mediaTime }}</span>
            </div>
            <!-- <div class="item">
              <span class="key">充值时间：</span>
              <span class="value">{{ rechargeInfo.mediaTime }}</span>
            </div> -->
          </div>
        </div>
        <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">退款信息</van-divider>
        <div class="card" style="padding: 5px;min-height: 20px;margin-bottom: 0" v-if="refundFront.isAd === 1">
          <div class="list-wrap van-hairline--top" style="padding-top: 0">
            <div class="item" style="width: 45%">
              <span class="key">需预留保证金：</span>
              <span class="value">{{ refundFront.deposit_amount }}</span>
            </div>
            <div class="item" style="width: 55%">
              <span class="key">可转账户币余额：</span>
              <span class="value">{{ refundFront.cash_transfer_balance }}</span>
            </div>
          </div>
        </div>
        <van-cell title="退款类型：" required>
          <template>
            <van-radio-group v-model="refundForm.refundType" direction="horizontal">
              <van-radio :name="1" clickable>退款</van-radio>
              <van-radio :name="2" clickable>调拨</van-radio>
            </van-radio-group>
          </template>
        </van-cell>
        <van-field v-if="refundForm.refundType == 2" readonly clickable v-model="refundForm.projectName" @click="showPicker('project')" label="项目名称" placeholder="请选择项目名称" :rules="[{ required: true }]" required ></van-field>
        <template v-if="refundForm.refundType == 2 && refundForm.projectId">
          <van-field readonly clickable v-model="refundForm.accountNo" @click="showPicker('accountNo')" label="账户ID" placeholder="请选择账户ID" :rules="[{ required: true }]" required />
          <van-field v-if="refundForm.accountNo" readonly clickable v-model="refundForm.serviceName" @click="showPicker('serviceId')" label="所属服务商ID" placeholder="请选择所属服务商ID" :rules="[{ required: true }]" required />
          <van-cell title="充值类型：" required>
            <template>
              <van-radio-group v-model="refundForm.mediaRechargeType" direction="horizontal" :disabled="accountType == 2">
                <van-radio :name="1" clickable>直充</van-radio>
                <van-radio :name="2" clickable>子账户子户</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field v-if="refundForm.mediaRechargeType === 2" readonly clickable v-model="refundForm.subAccountName" @click="showPicker('subAccountId')" label="子账户ID" placeholder="请选择子账户ID" :rules="[{ required: true }]" required />
          <van-field v-if="accountType == 1" readonly clickable v-model="refundForm.tenFundTypeName" @click="showPicker('tenFundType')" label="资金账号类型" placeholder="请选择资金账号类型" :rules="[{ required: true }]" required />
        </template>
        <van-field v-model="refundForm.rechargeMoney" @blur="getPayMoney('rechargeMoney',refundForm.rechargeMoney)" :disabled="refundForm.refundType == 2 && !refundForm.accountNo" label="账户币" placeholder="请输入账户币" type="number" :rules="[{ required: true }]" required />
        <van-field v-model="refundForm.payMoney" @blur="getPayMoney('payMoney',refundForm.payMoney)" :disabled="refundForm.refundType == 2 && !refundForm.accountNo" label="现金金额(元)" placeholder="请输入现金金额" type="number" :rules="[{ required: true }]" required >
          <template slot="right-icon">￥</template>
        </van-field>
        <template v-if="refundForm.refundType == 1">
          <van-field v-model="refundForm.refundUrl" label="客户截图" placeholder="请点击下方上传充值截图" :rules="[{ required: true }]" required readonly />
          <van-uploader class="pictureList" v-model="pictureList" :max-count="1" :after-read="uploadPictureFiles" :before-read="beforeRead" :before-delete="handleRemove" @oversize="onOversize" :max-size="10000 * 1024" />
          <div style="color: #ff976a; font-size: 14px;">只能上传一张jpg/png格式图片，且不超过10mb</div>
          <van-field v-model="refundForm.refundReason" label="退款原因" placeholder="请输入退款原因" type="textarea" rows="5" :rules="[{ required: true }]" required />
        </template>
      </van-form>
      <div class="footer">
        <van-button hairline type="defaut" plain @click="refundVisible = false">取消</van-button>
        <van-button hairline type="primary" plain @click="saveRefund">确认</van-button>
      </div>
    </van-dialog>
    <van-image-preview v-model="imageShow" :images="imageArr"></van-image-preview>
    <van-popup v-model="picker.visible" position="bottom">
      <van-search v-model="authIdQuery.accountId" placeholder="请输入账户ID查询" @search="onSearch" @input="onSearch" v-if="picker.formKey == 'accountNo'" />
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import channel from '@/api/channel/channel'
import { Toast, Dialog, ImagePreview } from 'vant'
import { getValue } from '@/utils/util'
import newContract from '@/api/cont/newContract'

export default {
  components: {
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {

      refundVisible: false,
      refundFront: {},
      rechargeInfo: {},

      projectList: [],
      authIdQuery: {
        pageNum: 1,
        pageSize: 100,
        projectId: null,
        accountId: null
      },
      authIdsList: [],
      serviceIdList: [],
      subAccountIdList: [],
      tenFundTypeList: [],
      accountType: null,

      refundForm: {
        rechargeMoney: null,
        payMoney: null,
        refundType: 1,
        refundReason: null,
        refundUrl: null,
        contNewIncomeDetailExecAccountId: null,
        isAd: null,

        projectId: null,
        accountNo: null,
        serviceId: null,
        accountSubType: null,
        mediaRechargeType: 1,
        subAccountId: null,
        tenFundType: null
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      imageShow: false,
      imageArr: [],
      pictureList: [],
      options: {
        tenFundTypeOptions: []
      }

    }
  },
  async mounted() {

  },
  methods: {
    // 详情
    async handleRefund(row) {
      console.log(row)
      this.rechargeInfo = row
      await channel.mediaRefundFront({ contNewIncomeDetailExecAccountId: row.contNewIncomeDetailExecAccountId }).then(res => {
        if (res.code === 200) {
          this.refundFront = res.data
        }
      })
      this.projectList = []
      this.authIdsList = []
      this.refundForm = {
        rechargeMoney: null,
        payMoney: null,
        refundType: 1,
        refundReason: null,
        refundUrl: null,
        contNewIncomeDetailExecAccountId: null,
        isAd: null,
        transferableMoney: null,

        projectId: null,
        accountNo: null,
        serviceId: null,
        accountSubType: null,
        mediaRechargeType: 1,
        subAccountId: null
      }
      if (row.execCustomerId) {
        await this.getProjectList(2, row.execCustomerId)
      } else {
        await this.getProjectList(1, row.contractId)
      }
      this.refundVisible = true
    },
    async getAuthIds(projectId) {
      await payment.listByProjectId(this.authIdQuery).then(res => {
        if (res.code == 200) {
          this.authIdsList = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    getPayMoney(type, val) {
      const params = {
        payMoney: null,
        rechargeMoney: null,
        fundType: this.rechargeInfo.fundType,
        projectId: this.refundForm.refundType == 2 ? this.refundForm.projectId : this.rechargeInfo.projectId,
        contractId: this.rechargeInfo.contractId
      }
      if (type == 'payMoney') {
        params.payMoney = val
        params.rechargeMoney = null
        channel.getPayMoney(params).then(res => {
          if (res.code == 200) {
            this.refundForm.rechargeMoney = res.data
          }
        })
      } else if (type == 'rechargeMoney') {
        params.payMoney = null
        params.rechargeMoney = val
        channel.getPayMoney(params).then(res => {
          if (res.code == 200) {
            this.refundForm.payMoney = res.data
          }
        })
      }
    },
    async getProjectList(type, id) {
      this.pointType = type
      await newContract.listProject({ bussType: type, bussId: id }).then(res => {
        if (res.code == 200) {
          this.projectList = res.rows
        }
      })
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'project') {
        this.picker.columns = this.projectList.map((ele) => `【${ele.projectId}】：${getValue(ele.projectName)} | ${ele.industryName ? ele.industryName : '-'}`)
        this.picker.loading = false
      } else if (type === 'accountNo') {
        this.picker.columns = this.authIdsList.map((ele) => ele.accountId)
        this.picker.loading = false
      } else if (type === 'serviceId') {
        this.picker.columns = this.serviceIdList.map((ele) => ele.accountId + '  ' + ele.remark)
        this.picker.loading = false
      } else if (type === 'subAccountId') {
        this.picker.columns = this.subAccountIdList.map((ele) => ele.accountId + '  ' + ele.remark)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      // const id = this.picker.formKey + 'Id'
      if (this.index || this.index == 0) {
        if (this.picker.formKey === 'accountNo') {
          if (this.authIdsForm.authIdsList.some(abc => { return abc.accountNo == this.authIdsList[key].accountId })) {
            Toast.fail('不能添加重复的账户ID')
            return
          }
          // this.authIdsList = this.authIdsList.filter(item => {
          //   return (item.accountId.toString()).indexOf(this.searchValue) > -1
          // })
          this.authIdsForm.authIdsList[this.index].accountNo = this.authIdsList[key].accountId
        } else {
          this.rechargeForm.flowList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.rechargeForm.flowList[this.index][name] = this.options[optionItem][key].dictLabel
        }
      } else {
        if (this.picker.formKey === 'project') {
          this.refundForm.projectId = this.projectList[key].projectId
          this.refundForm.projectName = this.projectList[key].projectName
          this.refundForm.accountNo = null
          this.refundForm.serviceId = null
          this.refundForm.serviceName = null
          this.refundForm.subAccountId = null
          this.refundForm.subAccountName = null
          this.refundForm.rechargeMoney = null
          this.refundForm.payMoney = null
          this.authIdQuery.projectId = this.refundForm.projectId
          this.getAuthIds(this.refundForm.projectId)
        } else if (this.picker.formKey === 'accountNo') {
          this.refundForm.accountNo = this.authIdsList[key].accountId
          this.refundForm.accountSubType = this.authIdsList[key].accountSubType
          this.accountType = this.authIdsList[key].accountType
          this.getContTencentAccountTokenList(this.authIdsList[key].accountType)
        } else if (this.picker.formKey === 'serviceId') {
          this.refundForm.serviceName = this.serviceIdList[key].accountId + '  ' + this.serviceIdList[key].remark
          this.refundForm.serviceId = this.serviceIdList[key].accountId
        } else if (this.picker.formKey === 'subAccountId') {
          this.refundForm.subAccountName = this.subAccountIdList[key].accountId + '  ' + this.subAccountIdList[key].remark
          this.refundForm.subAccountId = this.subAccountIdList[key].accountId
        } else if (this.picker.formKey === 'tenFundType') {
          this.refundForm.tenFundType = this.options[optionItem][key].dictValue
          this.refundForm.tenFundTypeName = this.options[optionItem][key].dictLabel
        } else {
          this.bindForm[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.bindForm[name] = this.options[optionItem][key].dictLabel
        }
      }
      this.picker.visible = false
    },
    async onSearch() {
      await this.getAuthIds()
      this.picker.columns = this.authIdsList.map((ele) => ele.accountId)
    },
    pickerCancel() {
      this.picker.visible = false
    },
    async getContTencentAccountTokenList(accountType) {
      await payment.getContTencentAccountTokenList({ accountType }).then(res => {
        if (res.code === 200) {
          this.serviceIdList = res.data
        }
      })
      await payment.getSubAccountTokenList({ accountType }).then(res => {
        if (res.code === 200) {
          this.subAccountIdList = res.data
        }
      })
      if (this.serviceIdList.length == 1) {
        this.refundForm.serviceId = this.serviceIdList[0].accountId
      }
      if (accountType === 1) {
        await this.getDicts('finance_account_type').then(res => {
          this.options.tenFundTypeOptions = res.data
          this.refundForm.tenFundType = 'FUND_TYPE_CASH'
          this.refundForm.tenFundTypeName = '现金账户'
        })
      }
    },
    // 返回布尔值
    beforeRead(file) {
      const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
      if (!imgArr.some((item) => { return file.type === item })) {
        Toast('请上传 图片 文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 10mb')
    },
    async uploadPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.refundForm.refundUrl = res.url
            this.pictureList = []
            this.pictureList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    handleRemove(file) {
      this.refundForm.refundUrl = ''
      this.pictureList = []
      return true
    },
    async saveRefund() {
      await this.$refs.refundForm.validate()
      this.refundForm.contNewIncomeDetailExecAccountId = this.rechargeInfo.contNewIncomeDetailExecAccountId
      this.refundForm.isAd = this.refundFront.isAd
      if (this.refundFront.isAd && this.refundFront.isAd == 1) {
        this.refundForm.transferableMoney = this.refundFront.cash_transfer_balance
      }
      if (this.refundForm.refundType == 1) {
        this.refundForm.projectId = null
        this.refundForm.serviceId = null
        this.refundForm.accountNo = null
        this.refundForm.accountSubType = null
        this.refundForm.mediaRechargeType = null
        this.refundForm.subAccountId = null
        this.refundForm.tenFundType = null
      } else if (this.refundForm.refundType == 2) {
        this.refundForm.refundReason = null
        this.refundForm.refundUrl = null
      }
      await channel.mediaRefund(this.refundForm).then(response => {
        if (response.code === 200) {
          Toast.success(response.msg)
          this.refundVisible = false
          this.refundForm = {
            rechargeMoney: null,
            payMoney: null,
            refundType: 1,
            refundReason: null,
            refundUrl: null,
            contNewIncomeDetailExecAccountId: null,
            isAd: null,
            transferableMoney: null,

            projectId: null,
            accountNo: null,
            serviceId: null,
            accountSubType: null,
            mediaRechargeType: 1,
            subAccountId: null
          }
          this.pictureList = []
          this.$parent.getRechargeList()
        } else {
          Toast.fail(response.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

.editClue /deep/.van-dialog__content {
  height: 82%;
}
.editClue /deep/.van-dialog__footer{
  display: none;
}
.footer{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 50%;
    border: 1px #f4f4f4 solid;
  }
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
.pictureList{
  margin-left: 30px;
  margin-top: 10px;
}
</style>
